<template>
    <div class="page-main">
        <div class="vertify-title">认证管理</div>
        <div class="text-color-grey" v-if="!centerInfo">加载失败请稍后重试</div>
        <div class="vertify-li spaceLeft" v-for="item in centerInfo" :key="item.name">
            <div class="vertify-li-title">{{item.header}}</div>
            <div class="width-auto">
                <span v-if="item.name!=='aprvSt' || securityInfo.aprvSt!=='2'">{{item.content}}</span>
                <a-popover v-else>
                    <template slot="content">
                        <h5>审核意见</h5>
                        <p>{{aproPopContent}}</p>
                    </template>
                    <span>{{item.content}}</span>
                </a-popover>
            </div>
            <div>
                <span v-if="item.remark">{{ item.remark }}</span>
                <a v-if="item.modifyText"  @click="item.modifyFlag=!item.modifyFlag">{{ item.modifyText }}</a>
                <template v-if="item.routersFlag">
                    <a v-for="oper in item.routers" :key="oper.text" @click="toPage(oper.uri)">{{oper.text}}</a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {getUserInfo,getApproveInfoByAprvId} from "@/api/security.js"
export default {
    name:"vertify-management",
    data() {
        return {
            securityInfo:{},
            centerInfo:null
        };
    },
    computed: {},
    methods: {
        getUserInfo(){
            getUserInfo(null,true)
            .then(res => {
                const info = this.securityInfo = res.data;
                if (res.data.aprvSt === '2') {
                    this.getApproveInfoByAprvId(res.data.aprvId);
                }
                this.centerInfo = [
                    {
                        name: 'cst',
                        header: '企业信息',
                        // tslint:disable-next-line:prefer-template
                        content: info.cstNm + ' ( 统一社会信用代码 : ' + info.orgCode + ' )',
                        routersFlag: true,
                        routers: [{
                        text: '查看',
                        uri: 'security/vertify'
                        }],
                    }, {
                        name: 'mobile',
                        header: '管理员信息',
                        state: !!info.mobile,
                        content: info.mnpltPsnNm && info.certificateNum ? `${info.mnpltPsnNm || ''}　　( 身份证号: ${info.certificateNum} )` : '',
                        remark: info.isChange ? '管理员信息审核中' : '',
                        routersFlag: !info.isChange && +info.aprvSt === 1,
                        routers: [{
                        text: info.isChange ? '查看' : '修改',
                        uri: 'security/operator-modify'
                        }],
                    }, {
                        name: 'confirmSt',
                        header: '发票信息',
                        state: info.confirmStatus === 1,
                        content: info.confirmStatus === 1 ? '已设置' : '未设置',
                        modifyFlag: false,
                        routersFlag: true,
                        routers: [{
                            text: '修改',
                            uri: 'security/updateoi'
                        }, {
                            text: '查看',
                            uri: 'security/queryoi'
                        }]
                    },
                ];
            })
            .catch(err => {
                console.log(err);
            })
        },
        getApproveInfoByAprvId(aprvId){
            getApproveInfoByAprvId({aprvId: aprvId})
            .then(resData => {
                this.aproPopContent = resData.data.apvOpn || "";
            })
            .catch(err => {
                console.log(err);
            });
        },
        toPage(path){
            this.MENUAPI.goToOneTab({
                path:path

            })
        }
    },
    created() {
        this.getUserInfo();
    },
    mounted() {

    },
    watch: {}
};
</script>
<style scoped>
    .vertify-title{
        font-size: 14px;
        color: #667380;
        line-height: 20px;
        font-family: Lucida Grande, Lucida Sans Unicode, Hiragino Sans GB, WenQuanYi Micro Hei, Verdana, Aril, sans-sefi, 微软雅黑;
        letter-spacing: 0;
        margin:15px 0;
    }
    .vertify-li-title{
        color:#0d253e;
        font-weight: bold;
        max-width: 300px;
        width: 30%;
    }
    .vertify-li{
        min-height: 75px;
        padding-left: 15px;
    }
    .vertify-li a{
        margin:0 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/security/vertify/vertify-management.vue